import {
  Coins,
  Wand2,
  LayoutTemplate,
  MessageCircle,
  SlidersHorizontal,
  type LucideIcon,
} from "lucide-react";

export interface NewsSlide {
  id: number;
  /** URL de imagen — cuando existe, el slide muestra solo la imagen */
  imageUrl?: string;
  /** Contenido placeholder (se usa solo si NO hay imageUrl) */
  title?: string;
  bullets?: string[];
  ctaText?: string;
  ctaUrl?: string;
  /** Icono decorativo del slide placeholder */
  decorativeIcon?: LucideIcon;
  /** Icono para la lista de noticias debajo del carrusel */
  listIcon: LucideIcon;
  /** Titulo para la lista de noticias */
  listTitle: string;
}

/** Mapeo de strings del JSON remoto a iconos Lucide */
export const ICON_MAP: Record<string, LucideIcon> = {
  Coins,
  Wand2,
  LayoutTemplate,
  MessageCircle,
  SlidersHorizontal,
};

/** URL del JSON remoto en S3/CDN */
export const NEWS_JSON_URL =
  "https://fluxi.co/prod/assets/banners/home-news.json";

/** Intervalo de auto-rotacion por defecto (ms) */
export const DEFAULT_AUTO_ROTATE_MS = 30000;

/** Slides por defecto (fallback si el fetch falla) */
export const DEFAULT_SLIDES: NewsSlide[] = [
  {
    id: 1,
    imageUrl: "https://fluxi.co/prod/assets/banners/01-creditos.webp",
    listIcon: Coins,
    listTitle: "Nuevo sistema de creditos: 1,000 creditos por plan",
  },
  {
    id: 2,
    imageUrl: "https://fluxi.co/prod/assets/banners/02-ad-studio.webp",
    listIcon: Wand2,
    listTitle: "Ad Studio: genera hasta 20 creativos con IA",
  },
  {
    id: 3,
    imageUrl: "https://fluxi.co/prod/assets/banners/03-secciones-ia.webp",
    listIcon: LayoutTemplate,
    listTitle: "Secciones con IA: personaliza cada funnel al 100%",
  },
  {
    id: 4,
    imageUrl: "https://fluxi.co/prod/assets/banners/04-whatsapp.webp",
    listIcon: MessageCircle,
    listTitle: "WhatsApp en Thank You Page: contacto post-venta directo",
  },
  {
    id: 5,
    imageUrl: "https://fluxi.co/prod/assets/banners/05-checkout.webp",
    listIcon: SlidersHorizontal,
    listTitle: "Checkout personalizable: arrastra campos y optimiza conversion",
  },
];
